import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {environment} from 'src/environments/environment';

import {BrandService} from 'src/app/shared/services/brand/brand.service';
import {Brands} from 'src/app/shared/constants/brands.constants';

@Injectable({providedIn: 'root'})
export class MapLoaderService {
  private loaded = false;
  private brand?: Brands;
  constructor(
    @Inject(DOCUMENT) private _document,
    private readonly brandService: BrandService,
  ) {
  }

  load(renderer2): Promise<void> {
    if (this.loaded) return Promise.resolve();
    this.brand = this.brandService.getCurrentBrand();

    const googleScriptUrl = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKeys[this.brand]}`;
    const clustererScriptUrl = 'https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js';

    const script = renderer2.createElement('script');
    script.type = 'text/javascript';
    renderer2.appendChild(this._document.body, script);

    return new Promise((resolve, reject) => {
      const script = renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = googleScriptUrl;

      script.onload = () => {
        const script = renderer2.createElement('script');
        script.type = 'text/javascript';

        script.src = clustererScriptUrl;

        script.onload = () => {
          this.loaded = true;
          resolve();
        };

        script.onerror = () => reject(new Error('Failed to load MarkerClusterer'));
        renderer2.appendChild(this._document.body, script);
      };

      script.onerror = () => reject(new Error('Failed to load Google Maps JS API'));
      renderer2.appendChild(this._document.body, script);
    });
  }
}
